import { Record, Map, Set } from "immutable"

import { INIT, SUCCESS, LOADING, ERROR } from "common/consts/phase"
import { requestPendingService } from "../api/manageApi"
import { reloadBooking, closeModal } from "../index"
import { bookedAtSelector } from "common/services/branding/selectors"

const INITIALIZE = "pendingAdditionalServices/INITIALIZE"
const SELECT = "pendingAdditionalServices/SELECT"
const DESELECT = "pendingAdditionalServices/DESELECT"

const SUBMIT = "pendingAdditionalServices/SUBMIT"
const SUBMIT_REQUEST = "pendingAdditionalServices/SUBMIT_REQUEST"
const SUBMIT_SUCCESS = "pendingAdditionalServices/SUBMIT_SUCCESS"
const SUBMIT_FAILURE = "pendingAdditionalServices/SUBMIT_FAILURE"

const InitialState = new Record({
  selected: new Set(),
  submitPhase: INIT,
  submitError: null,
})

function toInitialState(state: Map): InitialState {
  return new InitialState({
    ...state.toJS(),
    selected: new Set(),
  })
}

export default function pendingAdditionalServicesReducer(state = new InitialState(), action) {
  if (!(state instanceof InitialState)) return toInitialState(state)

  switch (action.type) {
    case INITIALIZE:
      return new InitialState({ selected: new Set() })

    case SELECT:
      return state.update("selected", selected => selected.add(action.service))

    case DESELECT:
      return state.update("selected", selected => selected.delete(action.service))

    case SUBMIT_REQUEST:
      return state.set("submitPhase", LOADING)

    case SUBMIT_SUCCESS:
      return state.set("submitPhase", SUCCESS)

    case SUBMIT_FAILURE:
      return state.set("submitPhase", ERROR).set("submitError", String(action.error))

    default:
      return state
  }
}

export function selectService(service) {
  return {
    type: SELECT,
    service,
  }
}

export function deselectService(service) {
  return {
    type: DESELECT,
    service,
  }
}

export function initialize() {
  return {
    type: INITIALIZE,
  }
}

export function submitServices(services: Set, bid) {
  return async (dispatch, getState) => {
    const booked_at = bookedAtSelector(getState()) // eslint-disable-line
    const promises = services.map(service => requestPendingService({ service, bid, booked_at }))

    const promise = Promise.all(promises)
    const submitted = await dispatch({ type: SUBMIT, promise, _track: true })
    await dispatch(reloadBooking(bid))

    // close modal after 3.5s
    if (submitted) {
      setTimeout(() => dispatch(closeModal(bid)), 3500)
    }
  }
}
